import { datadogRum } from '@datadog/browser-rum';
import { Component, ErrorInfo, ReactNode } from 'react';
import ErrorFallback from '@components/ErrorFallback';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  // eslint-disable-next-line class-methods-use-this
  componentDidCatch(error: Error, info: ErrorInfo) {
    if (typeof datadogRum?.addError === 'function') {
      datadogRum.addError(error, { componentStack: info.componentStack });
    }
  }

  render() {
    if (this.state.hasError) {
      return <ErrorFallback />;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
